import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['redirectHolder'];

  redirectHolderTarget: HTMLElement;

  hasRedirectHolderTarget: boolean;

  nextStep({ target }: { target: HTMLElement }): void {
    // @ts-expect-error TS2345 violates strict null checks
    const step = parseInt(target.dataset.step, 10);

    if (target.dataset.isLastStep === 'true') {
      this.closeAndRedirect();
      return;
    }

    const currentStep = document.querySelector(`[data-page="${step}"]`);
    if (currentStep) {
      currentStep.classList.add('u-displayNone');

      const el = document.querySelector<HTMLElement>(`[data-page="${step + 1}"]`);

      if (el) {
        el.classList.remove('u-displayNone');
      }
    }
  }

  toggleStep(el: HTMLElement) {
    el.classList.toggle('u-displayNone');
  }

  closeAndRedirect() {
    const close = document.querySelector<HTMLElement>('.sc-Modal-close');
    // @ts-expect-error TS18047 violates strict null checks
    close.click();
    if (this.hasRedirectHolderTarget) {
      // @ts-expect-error TS2322 violates strict null checks
      window.location.href = this.redirectHolderTarget.dataset.redirectValue;
    }
  }
}
